export default __webpack_public_path__ + "static/media/automotive-background-card.a93e13a9.png";